const body = document.querySelector( 'body' )
const { clientHeight : headerHeight } = document.querySelector( 'header' )

document.addEventListener( 'scroll', ( e ) => {

  const { scrollTop } = e.target.scrollingElement

  if( scrollTop > headerHeight ) body.classList.add( 'scrolled' )
  else body.classList.remove( 'scrolled' )

})
